import React from 'react';
import type { LineStyleT } from '../../constants/relationship-renderer';
import { LINE_STYLE, STROKE_DASHARRAY } from '../../constants/relationship-renderer';
import { CSS_VARIABLE_STAGE_STROKE_WIDTH } from '../../constants/stage-css-variables';
type PropsT = {
  sourceX: number;
  sourceY: number;
  targetX: number;
  targetY: number;
  color: string;
  lineStyle: LineStyleT;
};
const EdgeLine = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
  color,
  lineStyle
}: PropsT) => <line x1={sourceX} y1={sourceY} x2={targetX} y2={targetY} stroke={color} strokeDasharray={lineStyle === LINE_STYLE.DASHED ? STROKE_DASHARRAY : undefined} style={{
  strokeWidth: `var(${CSS_VARIABLE_STAGE_STROKE_WIDTH})`
}} />;
export default EdgeLine;